"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/transfer-request.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Ftransfer-request.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferRequestTypeToJSON = exports.transferRequestTypeFromJSON = exports.TransferRequestTransferCounterparty = exports.TransferRequestTransferUser = exports.TransferRequestFrom = exports.TransferRequest = exports.TransferRequestType = void 0;
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const legal_name_1 = require("../common/legal-name");
const transfer_request_status_1 = require("../common/transfer-request-status");
const protobufPackage = 'com.step.transfer.proto';
var TransferRequestType;
(function (TransferRequestType) {
    TransferRequestType["INVALID_TRANSFER_REQUEST_TYPE"] = "INVALID_TRANSFER_REQUEST_TYPE";
    /**
     * RECEIVE - Transfer request to receive money.
     */
    TransferRequestType["RECEIVE"] = "RECEIVE";
    /**
     * SEND - Transfer request to send money.
     */
    TransferRequestType["SEND"] = "SEND";
    TransferRequestType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransferRequestType || (exports.TransferRequestType = TransferRequestType = {}));
function createBaseTransferRequest() {
    return {
        id: '',
        from: exports.TransferRequestFrom.fromPartial({}),
        user: exports.TransferRequestTransferUser.fromPartial({}),
        counterparty: exports.TransferRequestTransferCounterparty.fromPartial({}),
        type: TransferRequestType.INVALID_TRANSFER_REQUEST_TYPE,
        amount: amount_1.Amount.fromPartial({}),
        description: '',
        requestedAtMs: '0',
        expiresAtMs: '0',
        status: transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS,
        reimburseTransactionId: '',
    };
}
exports.TransferRequest = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            from: isSet(object.from)
                ? exports.TransferRequestFrom.fromJSON(object.from)
                : exports.TransferRequestFrom.fromPartial({}),
            user: isSet(object.user)
                ? exports.TransferRequestTransferUser.fromJSON(object.user)
                : exports.TransferRequestTransferUser.fromPartial({}),
            counterparty: isSet(object.counterparty)
                ? exports.TransferRequestTransferCounterparty.fromJSON(object.counterparty)
                : exports.TransferRequestTransferCounterparty.fromPartial({}),
            type: isSet(object.type)
                ? transferRequestTypeFromJSON(object.type)
                : TransferRequestType.INVALID_TRANSFER_REQUEST_TYPE,
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            requestedAtMs: isSet(object.requestedAtMs) ? globalThis.String(object.requestedAtMs) : '0',
            expiresAtMs: isSet(object.expiresAtMs) ? globalThis.String(object.expiresAtMs) : '0',
            status: isSet(object.status)
                ? (0, transfer_request_status_1.transferRequestStatusFromJSON)(object.status)
                : transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS,
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.reimburseTransactionId)) {
            message.reimburseTransactionId = globalThis.String(object.reimburseTransactionId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.from !== undefined) {
            obj.from = exports.TransferRequestFrom.toJSON(message.from);
        }
        if (message.user !== undefined) {
            obj.user = exports.TransferRequestTransferUser.toJSON(message.user);
        }
        if (message.counterparty !== undefined) {
            obj.counterparty = exports.TransferRequestTransferCounterparty.toJSON(message.counterparty);
        }
        if (message.type !== TransferRequestType.INVALID_TRANSFER_REQUEST_TYPE) {
            obj.type = transferRequestTypeToJSON(message.type);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.requestedAtMs !== '0') {
            obj.requestedAtMs = message.requestedAtMs;
        }
        if (message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        if (message.status !== transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS) {
            obj.status = (0, transfer_request_status_1.transferRequestStatusToJSON)(message.status);
        }
        if (message.reimburseTransactionId !== undefined && message.reimburseTransactionId !== '') {
            obj.reimburseTransactionId = message.reimburseTransactionId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferRequest();
        message.id = object.id ?? '';
        message.from = (object.from !== undefined && object.from !== null)
            ? exports.TransferRequestFrom.fromPartial(object.from)
            : exports.TransferRequestFrom.fromPartial({});
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.TransferRequestTransferUser.fromPartial(object.user)
            : exports.TransferRequestTransferUser.fromPartial({});
        message.counterparty = (object.counterparty !== undefined && object.counterparty !== null)
            ? exports.TransferRequestTransferCounterparty.fromPartial(object.counterparty)
            : exports.TransferRequestTransferCounterparty.fromPartial({});
        message.type = object.type ?? TransferRequestType.INVALID_TRANSFER_REQUEST_TYPE;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        message.requestedAtMs = object.requestedAtMs ?? '0';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        message.status = object.status ?? transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS;
        message.reimburseTransactionId = object.reimburseTransactionId ?? '';
        return message;
    },
};
function createBaseTransferRequestFrom() {
    return { name: legal_name_1.LegalName.fromPartial({}), phone: '', pictureUrl: '' };
}
exports.TransferRequestFrom = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? legal_name_1.LegalName.fromJSON(object.name) : legal_name_1.LegalName.fromPartial({}),
            phone: isSet(object.phone) ? globalThis.String(object.phone) : '',
        };
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== undefined) {
            obj.name = legal_name_1.LegalName.toJSON(message.name);
        }
        if (message.phone !== '') {
            obj.phone = message.phone;
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        return obj;
    },
    create(base) {
        return exports.TransferRequestFrom.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferRequestFrom();
        message.name = (object.name !== undefined && object.name !== null)
            ? legal_name_1.LegalName.fromPartial(object.name)
            : legal_name_1.LegalName.fromPartial({});
        message.phone = object.phone ?? '';
        message.pictureUrl = object.pictureUrl ?? '';
        return message;
    },
};
function createBaseTransferRequestTransferUser() {
    return {
        userId: '',
        accountId: '',
        legalName: legal_name_1.LegalName.fromPartial({}),
        phone: '',
        pictureUrl: '',
    };
}
exports.TransferRequestTransferUser = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            legalName: isSet(object.legalName)
                ? legal_name_1.LegalName.fromJSON(object.legalName)
                : legal_name_1.LegalName.fromPartial({}),
            phone: isSet(object.phone) ? globalThis.String(object.phone) : '',
        };
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        if (message.phone !== '') {
            obj.phone = message.phone;
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        return obj;
    },
    create(base) {
        return exports.TransferRequestTransferUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferRequestTransferUser();
        message.userId = object.userId ?? '';
        message.accountId = object.accountId ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : legal_name_1.LegalName.fromPartial({});
        message.phone = object.phone ?? '';
        message.pictureUrl = object.pictureUrl ?? '';
        return message;
    },
};
function createBaseTransferRequestTransferCounterparty() {
    return { userId: '', alias: undefined };
}
exports.TransferRequestTransferCounterparty = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.alias)) {
            message.alias = alias_1.Alias.fromJSON(object.alias);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        return obj;
    },
    create(base) {
        return exports.TransferRequestTransferCounterparty.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferRequestTransferCounterparty();
        message.userId = object.userId ?? '';
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : undefined;
        return message;
    },
};
function transferRequestTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TRANSFER_REQUEST_TYPE':
            return TransferRequestType.INVALID_TRANSFER_REQUEST_TYPE;
        case 1:
        case 'RECEIVE':
            return TransferRequestType.RECEIVE;
        case 2:
        case 'SEND':
            return TransferRequestType.SEND;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransferRequestType.UNRECOGNIZED;
    }
}
exports.transferRequestTypeFromJSON = transferRequestTypeFromJSON;
function transferRequestTypeToJSON(object) {
    switch (object) {
        case TransferRequestType.INVALID_TRANSFER_REQUEST_TYPE:
            return 'INVALID_TRANSFER_REQUEST_TYPE';
        case TransferRequestType.RECEIVE:
            return 'RECEIVE';
        case TransferRequestType.SEND:
            return 'SEND';
        case TransferRequestType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transferRequestTypeToJSON = transferRequestTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=transfer-request.js.map